export default __webpack_public_path__ + "static/media/0.7ba96f76.jpg";